import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {LoginRequestDto} from './dtos/login-request.dto';
import {Observable} from 'rxjs';
import {LoginResponseDto} from './dtos/login-response.dto';
import {environment} from '../../../environments/environment';
import {RefreshDto} from './dtos/refresh.dto';
import {VerifyDto} from './dtos/verify.dto';
import {ResetPasswordDto} from './dtos/reset-password.dto';
import {SetPasswordDto} from './dtos/set-password.dto';
import {ExchangeTokenDto} from './dtos/exchange-token.dto';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
  http: HttpClient = inject(HttpClient);

  login(loginRequestDto: LoginRequestDto): Observable<LoginResponseDto> {
    return this.http.post<LoginResponseDto>(`${environment.cenplexBookingApiBaseUrl}/patients/login`, loginRequestDto);
  }

  loginAsManager(loginRequestDto: LoginRequestDto): Observable<LoginResponseDto> {
    return this.http.post<LoginResponseDto>(`${environment.cenplexBookingApiBaseUrl}/manager/login`, loginRequestDto);
  }

  refresh(refreshDto: RefreshDto): Observable<LoginResponseDto> {
    return this.http.post<LoginResponseDto>(`${environment.cenplexBookingApiBaseUrl}/patients/refresh-token`, refreshDto);
  }

  verify(verifyDto: VerifyDto): Observable<LoginResponseDto> {
    return this.http.post<LoginResponseDto>(`${environment.cenplexBookingApiBaseUrl}/patients/verify`, verifyDto);
  }

  grantAccess(verifyDto: VerifyDto): Observable<null> {
    return this.http.post<null>(`${environment.cenplexBookingApiBaseUrl}/people/verify`, verifyDto);
  }

  resetPassword(resetPasswordDto: ResetPasswordDto): Observable<null> {
    return this.http.post<null>(`${environment.cenplexBookingApiBaseUrl}/patients/reset-password`, resetPasswordDto);
  }

  setPassword(setPasswordDto: SetPasswordDto): Observable<null> {
    return this.http.post<null>(`${environment.cenplexBookingApiBaseUrl}/patients/set-password`, setPasswordDto);
  }

  redeemExchangeToken(exchangeTokenDto: ExchangeTokenDto): Observable<RefreshDto> {
    return this.http.post<RefreshDto>(`${environment.cenplexBookingApiBaseUrl}/patients/exchange-token/redeem`, exchangeTokenDto);
  }
}
